import React, { useState, useCallback } from 'react';
import { Box, Button, TextField, Typography, Paper } from '@mui/material';
import Layout from '../components/Layout';
import { TwilioVideoViewer } from '../components/twilio/TwilioVideoViewer';
import { VideoAPI } from '../api/VideoAPI';

export const TransmissionRooms = () => {
    const [inputGuid, setInputGuid] = useState('');
    const [activeGuid, setActiveGuid] = useState(null);

    const getToken = useCallback(() => VideoAPI.getAdminToken(activeGuid), [activeGuid]);

    const handleAccess = (e) => {
        e.preventDefault();
        const g = inputGuid.trim();
        if (g) {
            setActiveGuid(g);
        }
    };

    const handleLeave = () => {
        setActiveGuid(null);
    };

    return (
        <Layout height="calc(100vh - 100px)">
            <Typography variant="h4" component="h1" color="primary" gutterBottom>
                Salas de transmissão
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Informe o GUID do atendimento em andamento para acompanhar a transmissão como administrador.
            </Typography>

            <Paper sx={{ p: 2, mb: 3, maxWidth: 560 }}>
                <Box component="form" onSubmit={handleAccess} display="flex" gap={2} flexWrap="wrap" alignItems="flex-start">
                    <TextField
                        label="GUID do atendimento"
                        value={inputGuid}
                        onChange={(e) => setInputGuid(e.target.value)}
                        size="small"
                        fullWidth
                        sx={{ flex: '1 1 280px' }}
                    />
                    <Button type="submit" variant="contained" disabled={!inputGuid.trim()}>
                        Acessar sala
                    </Button>
                    {activeGuid && (
                        <Button type="button" variant="outlined" onClick={handleLeave}>
                            Sair
                        </Button>
                    )}
                </Box>
            </Paper>

            {activeGuid && <TwilioVideoViewer key={activeGuid} getToken={getToken} />}
        </Layout>
    );
};
